<ngx-loading-bar
  color="#EA670F"
  [includeSpinner]="false"
  [includeBar]="true"
></ngx-loading-bar>
<router-outlet></router-outlet>
